/*
 * Joon product-gallery thumbnails
 * ------------------------------------------------------------------
 * Adds a synced thumbnail carousel BELOW the product media gallery on
 * product pages that use the "carousel" media style (where the theme
 * otherwise shows no thumbnails). Original, self-contained code.
 *
 * It drives the theme's existing Swiper gallery (clicking a thumb calls
 * swiper.slideTo) and mirrors the active slide by watching the gallery's
 * own `.swiper-slide-active` class — so it stays in sync no matter how the
 * slide changes (arrows, swipe, variant image grouping).
 * ------------------------------------------------------------------
 */
(function () {
  "use strict";

  var BUILT = "__jptBuilt";

  // Resize a Shopify CDN url to a small thumbnail width (server-side).
  function resize(url, w) {
    if (!url) return url;
    try {
      if (/\/cdn\/shop\//.test(url) || /cdn\.shopify\.com/.test(url)) {
        return url + (url.indexOf("?") > -1 ? "&" : "?") + "width=" + w;
      }
    } catch (e) {}
    return url;
  }

  // Resolve a reliable thumbnail source. Prefer the slide's `data-full-size`
  // (a complete master image URL rendered by the theme) so lazy-loaded slides
  // that haven't populated their <img src> yet still get a valid image.
  function thumbSrc(slide) {
    var df = slide.getAttribute("data-full-size");
    if (df && df.trim()) return resize(df.trim(), 200);
    var img = slide.querySelector("img");
    if (img) {
      if (img.currentSrc) return img.currentSrc;
      var ss = img.getAttribute("srcset") || img.getAttribute("data-srcset");
      if (ss) { var first = ss.trim().split(",")[0].trim().split(/\s+/)[0]; if (first) return first; }
      var s = img.getAttribute("src"); if (s && s.trim()) return s;
      var d = img.getAttribute("data-src"); if (d && d.trim()) return d;
    }
    var video = slide.querySelector("video,iframe");
    return (video && video.poster) || "";
  }

  function isVideoSlide(slide) {
    return !!slide.querySelector("video,iframe") ||
      /video/i.test(slide.className) ||
      slide.getAttribute("data-media-type") === "video";
  }

  function build(gallery) {
    var cont = gallery.querySelector(".theme-viewport.swiper-container") || gallery.querySelector(".swiper-container");
    if (!cont) return false;
    var sw = cont.swiper;
    if (!sw) return false; // Swiper not initialised yet — caller will retry.

    var slides = Array.prototype.slice.call(gallery.querySelectorAll(".theme-images > .theme-img"));
    var existing = gallery.querySelector(".jpt-thumbs");
    if (existing) existing.remove();
    if (slides.length < 2) { gallery[BUILT] = true; return true; }

    var strip = document.createElement("div");
    strip.className = "jpt-thumbs";

    slides.forEach(function (slide, i) {
      var b = document.createElement("button");
      b.type = "button";
      b.className = "jpt-thumb";
      b.setAttribute("aria-label", "Show product media " + (i + 1));
      var src = thumbSrc(slide);
      b.innerHTML =
        '<img src="' + src + '" alt="" loading="lazy">' +
        (isVideoSlide(slide) ? '<span class="jpt-thumb__play" aria-hidden="true"></span>' : "");
      b.addEventListener("click", function (e) {
        e.preventDefault();
        var s = cont.swiper;
        if (s && typeof s.slideTo === "function") s.slideTo(i);
      });
      strip.appendChild(b);
    });

    cont.parentNode.insertBefore(strip, cont.nextSibling);

    function activeIndex() {
      var a = gallery.querySelector(".theme-images .swiper-slide-active") ||
              gallery.querySelector(".theme-images .theme-img.current-img");
      return a ? slides.indexOf(a) : -1;
    }
    function sync() {
      var idx = activeIndex();
      var ts = strip.querySelectorAll(".jpt-thumb");
      for (var k = 0; k < ts.length; k++) ts[k].classList.toggle("is-active", k === idx);
      var act = strip.querySelector(".jpt-thumb.is-active");
      if (act) {
        var target = act.offsetLeft - (strip.clientWidth / 2) + (act.clientWidth / 2);
        try { strip.scrollTo({ left: target, behavior: "smooth" }); } catch (e) { strip.scrollLeft = target; }
      }
    }
    try {
      new MutationObserver(sync).observe(gallery.querySelector(".theme-images"),
        { subtree: true, attributes: true, attributeFilter: ["class"] });
    } catch (e) {}
    if (sw.on) { sw.on("slideChange", sync); sw.on("slideChangeTransitionEnd", sync); }
    sync();

    gallery[BUILT] = true;
    return true;
  }

  function tick(tries) {
    var galleries = Array.prototype.slice.call(document.querySelectorAll(".theme-gallery"));
    var pending = false;
    galleries.forEach(function (g) { if (!g[BUILT]) { if (!build(g)) pending = true; } });
    if (pending && tries < 40) setTimeout(function () { tick(tries + 1); }, 150);
  }

  function start() { tick(0); }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start);
  else start();

  // Swiper can initialise late; re-check after full load, and rebuild any
  // gallery whose strip went missing (e.g. after a variant re-render).
  window.addEventListener("load", function () {
    setTimeout(function () {
      document.querySelectorAll(".theme-gallery").forEach(function (g) {
        if (!g.querySelector(".jpt-thumbs")) g[BUILT] = false;
      });
      tick(0);
    }, 300);
  });
})();
